import { Component, OnInit, Inject } from '@angular/core';
import { MAT_DIALOG_DATA } from '@angular/material';
import { User } from 'src/app/model/user.model';
import { ExcelService } from 'src/app/services/excel/excel.service';

@Component({
  selector: 'app-download-xlsx',
  templateUrl: './download-xlsx.component.html',
  styleUrls: ['./download-xlsx.component.scss']
})
export class DownloadXlsxComponent implements OnInit {
 values: any;
 userListExcelDownload: User[] = [];
 excelDownloadData: any = [];
  constructor( @Inject(MAT_DIALOG_DATA) public data: any,
  private excelService: ExcelService) { }

  ngOnInit() {
    console.log('xls',this.data);
    
  }
  download() {
    //this.getData();
   //  this.ngOnInit();
 // this.college.getData();
 const fileName: any = this.data.name;
 this.values = this.data.funnelData;
 this.userListExcelDownload = this.values;

 if (this.values.length === 0) {
   const excelDownloadModel: any = new class {
     'S.NO': ''; 'Full Name': ''; 'Phone Number': ''; 'Gender': ''; 'Email id': '';
     'Qualification': ''; 'Year Of Passing': ''; 'Registered Date': ''; 'Permanent Pin Code': ''; 'Current Pin Code': '' ;'Refferal Name': '';'Refferal Contact No'
   };

   excelDownloadModel['S.NO'] = '';
   excelDownloadModel['Full Name'] = '';
   excelDownloadModel['Phone Number'] = '';
   excelDownloadModel['Gender'] = '';
   excelDownloadModel['Email id'] = '';
   excelDownloadModel['Qualification'] = '';
   excelDownloadModel['Year Of Passing'] = '';
   excelDownloadModel['Registered Date'] = '';
   excelDownloadModel['Permanent Pin Code'] = '';
   excelDownloadModel['Current Pin Code'] = '';
   excelDownloadModel['Refferal Name'] = '';
   excelDownloadModel['Refferal Contact No'] = '';
   this.excelDownloadData.push(excelDownloadModel);
   this.excelService.exportAsExcelFile(this.excelDownloadData, fileName);
 } else {

   let rowNumber: number = 0;

   for (const response of this.userListExcelDownload) {
     const excelDownloadModel: any = new class {
       'S.NO': ''; 'Full Name': ''; 'Phone Number': ''; 'Gender': ''; 'Email id': '';
       'Qualification': ''; 'Year Of Passing': ''; 'Registered Date': ''; 'Permanent Pin Code': ''; 'Current Pin Code': '';'Refferal Name':'';'Refferal Contact No':'';
     };
     excelDownloadModel['S.NO'] = ++rowNumber;
     excelDownloadModel['Full Name'] = response.fullName;
     excelDownloadModel['Phone Number'] = response.phoneNumber;
     excelDownloadModel['Gender'] = response.gender;
     excelDownloadModel['Email id'] = response.emailId;
     excelDownloadModel['Qualification'] = response.qualification;
     excelDownloadModel['Year Of Passing'] = response.graduationYear;
     excelDownloadModel['Registered Date'] = response.registeredDate;
     excelDownloadModel['Permanent Pin Code'] = response.permanentPinCode;
     excelDownloadModel['Current Pin Code'] = response.currentPinCode;
     excelDownloadModel['Refferal Name'] = response.referralName;
     excelDownloadModel['Refferal Contact No'] = response.referralContactNumber;
     this.excelDownloadData.push(excelDownloadModel);
   }
   this.excelService.exportAsExcelFile(this.excelDownloadData, fileName);
 }
 this.excelDownloadData = [];
}

}
